import { useState } from "react";

export default function useScreenSize() {
  const [screenSize, setScreenSize] = useState({
    width: window.screen.width,
    height: window.screen.height,
  });
  window.onresize = () => {
    //   if (window.screen.availWidth === screenSize.width && window.screen.)
    setScreenSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
    let x = window.matchMedia("(min-width: 1024px)");
    // console.log("on large screen:", x.matches, window.innerWidth >= 1024);
  };
  // console.log(screenSize);
  return {
    isLargeScreen: () => screenSize.width >= 1024,
  };
}
